
<div class="modal active" *ngIf="coverageDTO && antennaModels">
    <div class="modal__container modal__container--lg">
      <div class="fields">
        <h2>Antenna Model Association</h2>
        <div class="close" (click)="bsModalRef.hide()"><img src="/assets/img/close-white.svg" alt="" /></div>
        <div class="fields__container">
          <form autocomplete="off"  name="antennaPatternForm" #ngForm="ngForm" id="antennaPatternForm" class="active">
            <div class="fields__block">
              <div class="fields__block__section">
                <div class="table-fields">
                  <div style="max-height: 241px; overflow-y: scroll;">
                    <table>
                      <thead>
                        <tr>
                          <th scope="col">NavAid ID</th>
                          <th scope="col">NavAid Name</th>
                          <th scope="col">NavAid Type</th>
                          <th scope="col">NavAid ICAO CC</th>
                          <th scope="col">Antenna Model</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr mdbTableCol *ngFor="let navaid of this.coverageDTO.navaids; let i = index">
                          <td>{{ navaid.id }}</td>
                          <td>{{ navaid.name }}</td>
                          <td>{{ navaid.type }}</td>
                          <td>{{ navaid.icaocc }}</td>
                          <td>
                            <span>
                                <select
                                required="true"
                                [(ngModel)]="navaid.antennaModelName"
                                id="model_{{i}}"
                                name="model_{{i}}"
                              >
                                <option *ngFor="let model of antennaModels" [ngValue]="model.modelName">{{model.modelName}}</option>
                              </select></span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div class="fields__btn">
              <button (click)="proceedWithCalculation()" type="submit" [ngClass]="ngForm.form.valid && allSelected() ? 'blue' : 'gray'" >
                Ok
              </button>
              <button (click)="bsModalRef.hide()" type="submit" [ngClass]="'blue'" >
                Cancel
              </button>
            </div>
          </form>
  
        </div>
      </div>
    </div>
  </div>
  

